export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11109.f7999bdd.jpg";